import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="24" height="23" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="#666" fill="none" fillRule="evenodd" transform="translate(.5 .5)"><circle cx="20" cy="20" r="2" /><circle cx="11" cy="20" r="2" /><path d="M6.4 9h15.3M5 5h18l-2.5 8H7.9" /><path d="M0 0h3.5L9 15" /></g></svg>;